import {
  Badge,
  Box,
  Flex,
  Heading,
  IconButton,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { Shimmer } from "react-shimmer";
import {
  RecipeCollectionWithRecipesVm,
  RecipeVm,
} from "../../apiClient/clients";
import { useToggleRecipeFavourite } from "../../hooks";
import { brand500Color } from "../../pages/_app";
import getImageFromRecipe from "../../utils/getImageFromRecipe";
import { RecipeMenu } from "../Menus";
import RecipeCollectionRecipeCardMenu from "../Menus/RecipeCollectionRecipeCardMenu";

type Props = {
  recipe: RecipeVm;
  onClickUrl?: string;
  isAccessedFromCollectionPage?: boolean;
  recipeCollection?: RecipeCollectionWithRecipesVm;
  isCreatedByCurrentUser?: boolean;
};

const RecipeCardV2 = ({
  recipe,
  onClickUrl,
  isAccessedFromCollectionPage,
  recipeCollection,
  isCreatedByCurrentUser = false,
}: Props) => {
  const router = useRouter();
  const { isLoading, toggleRecipeFavourite } = useToggleRecipeFavourite({});
  return (
    <Box
      id={recipe.id}
      bg={useColorModeValue("white", "gray.800")}
      maxW="xs"
      h="310px"
      rounded="lg"
      shadow="lg"
      position="relative"
      onClick={() =>
        router.push(onClickUrl ? onClickUrl : `recipes/${recipe.id}`)
      }
    >
      <Flex justify={"center"}>
        {/* <LazyLoad height={"100%"} width={"100%"}> */}
        <Image
          // boxShadow="0px 4px 10px rgba(0, 0, 0, 0.1)" // Add this line
          // boxShadow="0px 4px 20px rgba(0, 0, 0, 0.2)" // Increase blur radius and opacity

          h={"200px"}
          w={"100%"}
          objectFit="cover"
          src={getImageFromRecipe({
            sizeOption: "500_500",
            recipeImage: recipe.recipeImages?.[0],
          })}
          alt={recipe.name}
          roundedTop="lg"
          fallback={
            <Flex justify={"center"} height="100%" w="100%">
              <Shimmer height={200} width={200} className="shimmer-max-width" />
            </Flex>
          }
        />
        {isCreatedByCurrentUser && (
          <IconButton
            color={brand500Color}
            aria-label="Favorite"
            icon={
              recipe?.isFavourite ? (
                <FaHeart size={24} />
              ) : (
                <FaRegHeart size={24} />
              )
            }
            position="absolute"
            top={2}
            left={2}
            isDisabled={isLoading}
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              toggleRecipeFavourite(recipe.id);
            }}
          />
        )}

        {/* </LazyLoad> */}
      </Flex>
      <Box h="110px" paddingLeft={"10px"} paddingTop="10px">
        <Flex>
          <Flex flex="1" gap="4" alignItems="center" flexWrap="wrap">
            <Box minH={"70px"}>
              <Heading wordBreak={"break-word"} noOfLines={3} fontSize="lg">
                {recipe.name}
              </Heading>
              {recipe.isGloballyVisible && !isAccessedFromCollectionPage && (
                <Badge marginBottom={"1"} colorScheme="green">
                  Featured
                </Badge>
              )}
            </Box>
          </Flex>
          <Flex>
            {isAccessedFromCollectionPage ? (
              <RecipeCollectionRecipeCardMenu
                recipe={recipe}
                isAccessedFromCollectionPage={isAccessedFromCollectionPage}
                recipeCollection={recipeCollection}
              />
            ) : (
              <RecipeMenu
                recipe={recipe}
                isAccessedFromCollectionPage={isAccessedFromCollectionPage}
              />
            )}
          </Flex>
        </Flex>
      </Box>
    </Box>
    // </Flex>
  );
};

export default RecipeCardV2;

/**Original Header */

// <Box h="100px" p="6">
// {/* <Box display="flex" alignItems="baseline"></Box> */}
// <Flex mt="1" justifyContent="space-between" alignContent="center">
//   <Box
//     fontSize="2xl"
//     fontWeight="semibold"
//     as="h4"
//     lineHeight="tight"
//     isTruncated
//   >
//     Food
//   </Box>
//   <Tooltip
//     label="Add to cart"
//     bg="white"
//     placement={"top"}
//     color={"gray.800"}
//     fontSize={"1.2em"}
//   >
//     <chakra.a href={"#"} display={"flex"}>
//       <Icon as={FiShoppingCart} h={7} w={7} alignSelf={"center"} />
//     </chakra.a>
//   </Tooltip>
// </Flex>

// <Flex justifyContent="space-between" alignContent="center">
//   <Box fontSize="2xl" color={useColorModeValue("gray.800", "white")}>
//     <Box as="span" color={"gray.600"} fontSize="lg">
//       £
//     </Box>
//   </Box>
// </Flex>
// </Box>
